import { api } from './api';

export const integrationsService = {
  listEvents: async (params = {}) => {
    const response = await api.get('/integrations/events', { params });
    return response.data;
  },

  retryEvent: async (eventId) => {
    const response = await api.post(`/integrations/events/${eventId}/retry`);
    return response.data;
  },
};
